import CustomTable from "../common/customTable";

export default function HoldingDetailsLoader(): JSX.Element {
    return (

        <CustomTable
            isLoading={true}
            tableHeaderData={[...Array(4)]}
            tableBodyLoaderRowCustomStyles={{
                '& td:first-of-type': {
                    paddingLeft: "0px"
                },
            }}
            tableHeadRowCustomStyles={{
                '& th:first-of-type': {
                    paddingLeft: "0px"
                }
            }}
            loadingRowsNum={5}
        />

    )
}